import { LoansInPendingStatusService } from './loansInPendingStatusService';

export const loansInPendingStatusService = new LoansInPendingStatusService();